// extracted by mini-css-extract-plugin
module.exports = {"menu":"antd-pro-components-select-lang-index-menu","langButton":"antd-pro-components-select-lang-index-langButton","langIcon":"antd-pro-components-select-lang-index-langIcon"};